import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import FormControlFeedback from "../formControlFeedback/formControlFeedback";

import "./radioButtonGroup.scss";

const RadioButtonGroup = ({
  children,
  description = null,
  inline = false,
  invalidFeedback = null,
  isInvalid = false,
  label,
  required = false,
  small = false,
}) => (
  <div
    className={
      classNames(
        "radio-button-group",
        {
          "radio-button-group--inline": inline,
          "radio-button-group--small": small,
        },
      )
    }
  >
    <div className="radio-button-group__content">
      <div className={classNames("radio-button-group__label", { required })}>
        {label}
      </div>
      {!inline && description && (
        <div className="radio-button-group__description">
          {description}
        </div>
      )}
      <div className="radio-button-group__options">
        {children}
      </div>
    </div>
    {isInvalid && invalidFeedback && (
      <FormControlFeedback>{invalidFeedback}</FormControlFeedback>
    )}
  </div>
);

RadioButtonGroup.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string,
  inline: PropTypes.bool,
  invalidFeedback: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  isInvalid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  small: PropTypes.bool,
};

export default RadioButtonGroup;
